import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {AccessTokenService} from '../core/access-token.service';

export interface TipsArticle {
  title: string;
  description: string;
}

@Injectable({
  providedIn: 'root'
})
export class HelpdeskApiService {
  // Injections
  private readonly accessTokenService: AccessTokenService = inject(AccessTokenService);
  private readonly http: HttpClient = inject(HttpClient);

  private readonly baseURL = `${environment.ekulturAPIGatewayURL}/helpdesk-api`;

  getTipsAndTricksArticles(lang?: string): Observable<{
    items: TipsArticle[]
  }> {

    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.accessTokenService.getToken(),
      'Id-Token': this.accessTokenService.getIdToken(),
      'Correlation-Id': crypto.randomUUID(),
    });
    const params = {
      language: lang,
      appId: environment.ekulturPrimusAppID,
    }
    return this.http.get<{
      items: TipsArticle[]
    }>(`${this.baseURL}/solution-articles/`, {
      headers,
      params,
    });
  }
}
